import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto',
    },
  },
};

function getStyles(name, status, theme) {
  return {
    fontWeight:
      status.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
        display:"block",
        paddingTop:"2px",
        paddingBottom:"6px",
        paddingLeft:"15px",
  };
}

 export default function MultipleSelect(props) {
const { options, label, onChange, name, value } = props;
const theme = useTheme();
const [multiselect, setMultiselect] = useState([]);

const normalizeValue = (nextValue) => {
  if (!nextValue) {
    return [];
  }
  return Array.isArray(nextValue) ? nextValue : [nextValue];
};

const MultiselecthandleChange = (event) => {
const statusset=event.target.value;
setMultiselect(statusset)
onChange(event)
};

useEffect(()=>{
 setMultiselect(normalizeValue(value));
},[value])

return (
  <div>
    <FormControl sx={{ m: 1, width: "100%" }}>
      <InputLabel>{label}</InputLabel>
      <Select
        labelId="demo-multiple-name-label border-box"
        id="demo-multiple-name"
        name={name}
        multiple
        value={multiselect}
        onChange={MultiselecthandleChange}
        input={<OutlinedInput label="multiselect" />}
        renderValue={(selected)=>selected.join(',')}
        isMulti={true}
        MenuProps={MenuProps}
      >
        {options.map((a) => (
          <MenuItem
            key={a}
            value={a}
            style={getStyles(a, multiselect, theme)}
           
          >
            {a}
            
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </div>
);
} 
